import React from 'react';
import { ReferenceInput, AutocompleteInput, SelectInput } from 'react-admin';

const CustomContactInput = ({ record }) => {
    return (
        <div>
            <div className="row row-cols-3 g-2 g-lg-3">
                <div>
                    <ReferenceInput source="contact_id" label={<h6 className="px-2 mb-5 align-self-center small" style={{ backgroundColor: 'white' }}>Name</h6>} resource="contacts" reference="contacts" filterToQuery={searchText => ({ display_name: searchText })}>
                        <AutocompleteInput className="bg-danger" resettable className="mb-0 pb-0" optionText="display_name" fullWidth variant="outlined" />
                    </ReferenceInput>
                </div>
                <div>
                    <ReferenceInput label={<h6 className="px-2 mb-5 align-self-center small" style={{ backgroundColor: 'white' }}>Phone</h6>} source="contact_id" reference="contacts">
                        <SelectInput optionText="phone" variant="outlined" fullWidth disabled />
                    </ReferenceInput>
                </div>
                <div>
                    <ReferenceInput label={<h6 className="px-2 mb-5 align-self-center small" style={{ backgroundColor: 'white' }}>Email</h6>} source="contact_id" reference="contacts">
                        <SelectInput optionText="email" variant="outlined" fullWidth disabled />
                    </ReferenceInput>
                </div>
            </div>
        </div>
    );
};

export default CustomContactInput;